/** Stable data-tour-id values. User-facing host is Pingflo, never Digiping. */
export const TOUR_IDS = {
  navProfile: "nav-profile",
  navHome: "nav-home",
  navDashboard: "nav-dashboard",
  navCompetition: "nav-competition",
  navPlanning: "nav-planning",
  navTraining: "nav-training",
  navLive: "nav-live",
  navParentHub: "nav-parent-hub",
  pingfloFab: "pingflo-fab",
  pingfloAgentTeam: "pingflo-agent-team",
  playerNewSession: "player-new-session",
  playerNextSessions: "player-next-sessions",
  playerCalendar: "player-calendar",
  coachGroups: "coach-groups",
  coachAddSession: "coach-add-session",
  adminDashboard: "admin-dashboard",
  adminUsersCard: "admin-users-card",
  adminGroupsCard: "admin-groups-card",
  adminNavGroups: "admin-nav-groups",
  adminNavInvite: "admin-nav-invite",
  adminNavDashboard: "admin-nav-dashboard",
  adminNavToggle: "admin-nav-toggle",
  adminPresenceCard: "admin-presence-card",
  adminPresenceChart: "admin-presence-chart",
  adminPresenceOpen: "admin-presence-open",
  adminPresenceBoard: "admin-presence-board",
  adminGroupsPage: "admin-groups-page",
  adminInvitePage: "admin-invite-page",
  adminInviteMethods: "admin-invite-methods",
  adminInviteMethodLink: "admin-invite-method-link",
  adminInviteMethodEmail: "admin-invite-method-email",
  adminInviteMethodQr: "admin-invite-method-qr",
  coachPlanningBoard: "coach-planning-board",
  coachSplitGroup: "coach-split-group",
  coachAddExercise: "coach-add-exercise",
  coachTrainingFloor: "coach-training-floor",
  liveTrainingOpen: "live-training-open",
  livePlayerTable: "live-player-table",
  livePlayerExercise: "live-player-exercise",
  livePlayerHr: "live-player-hr",
  liveCoachFloor: "live-coach-floor",
  liveCoachTables: "live-coach-tables",
  liveCoachStart: "live-coach-start",
  playerCompetition: "player-competition",
  competitionCalendar: "competition-calendar",
  profileSmartTab: "profile-smart-tab",
  profileSmartObjectives: "profile-smart-objectives",
  profileSmartTraining: "profile-smart-training",
  adminProfileSmart: "admin-profile-smart",
  parentHub: "parent-hub",
  parentChildren: "parent-children",
  parentSmart: "parent-smart",
  parentMedical: "parent-medical",
  parentRsvp: "parent-rsvp",
};

export const TOUR_ID_VALUES = Object.values(TOUR_IDS);

export const TOUR_ROLES = ["player", "coach", "admin", "parent"];

export function mapHomeRoleToTourRole(homeRole) {
  if (homeRole === "monitor") return "coach";
  if (homeRole === "committee") return "admin";
  if (homeRole === "tutor" || homeRole === "guardian") return "parent";
  if (TOUR_ROLES.includes(homeRole)) return homeRole;
  return "player";
}

export const PLAYBOOK_IDS = {
  welcomePlayer: "welcome.player",
  welcomeCoach: "welcome.coach",
  welcomeAdmin: "welcome.admin",
  welcomeParent: "welcome.parent",
  playerNewSession: "player.newSession",
  playerCompanion: "player.companion",
  coachAddSession: "coach.addSession",
  coachPlanning: "coach.planning",
  adminInvite: "admin.invite",
  adminGroups: "admin.groups",
  adminPresence: "admin.presence",
  playerCompetition: "player.competition",
  parentRsvp: "parent.rsvp",
  playerLive: "player.live",
  coachLive: "coach.live",
};

export const ALLOWED_PLAYBOOK_IDS = new Set(Object.values(PLAYBOOK_IDS));

export const LANDING_PATH_BY_ROLE = {
  player: "/home",
  coach: "/home",
  admin: "/Dashboard",
  parent: "/parent/progress",
};
